import { cn } from '../lib/utils';

interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  text?: string;
}

export default function Spinner({ size = 'md', className, text }: SpinnerProps) {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16',
  };

  return (
    <div className={cn('flex flex-col items-center justify-center gap-3', className)}>
      <div
        className={cn(
          'animate-spin rounded-full border-4 border-line border-t-brand',
          sizes[size]
        )}
      />
      {text && <p className="text-sm text-ink-2">{text}</p>}
    </div>
  );
}

export function FullPageSpinner({ text }: { text?: string }) {
  return (
    <div className="flex h-screen items-center justify-center">
      <Spinner size="xl" text={text || 'Loading...'} />
    </div>
  );
}
